import type { UseFormSetValue, UseFormWatch } from 'react-hook-form';

import type { ModelTrainingForm, Task } from '@/type';

import SplitCard from './SplitCard';

const SplitCardContainer = ({
  deletable = true,
  disabled = false,
  watch,
  setValue,
  updateTaskSplitRatio,
  getTaskSplitRatio,
}: {
  deletable?: boolean;
  disabled: boolean;
  watch: UseFormWatch<ModelTrainingForm>;
  setValue: UseFormSetValue<ModelTrainingForm>;
  updateTaskSplitRatio: (
    taskId: Task['id'],
    training: number,
    validation: number,
  ) => void;
  getTaskSplitRatio: (taskId: Task['id']) => {
    training: number;
    validation: number;
  };
}) => {
  const selectedTaskList = watch('selectedTaskList');

  return (
    <div className="grid grid-cols-2 gap-4">
      {selectedTaskList.map(task => (
        <SplitCard
          key={task.id}
          task={task}
          deletable={deletable}
          disabled={disabled}
          watch={watch}
          setValue={setValue}
          updateTaskSplitRatio={updateTaskSplitRatio}
          getTaskSplitRatio={getTaskSplitRatio}
        />
      ))}
    </div>
  );
};

export default SplitCardContainer;
